// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "YOUR_API_KEY",
//   authDomain: "campaleads-489609.firebaseapp.com",
//   projectId: "campaleads-489609",
//   storageBucket: "campaleads-489609.appspot.com",
//   messagingSenderId: "XXXX",
//   appId: "XXXX"
// };

// const app = initializeApp(firebaseConfig);

// export const db = getFirestore(app);

import { initializeApp } from "firebase/app";

import {
  getFirestore
} from "firebase/firestore";

import {
  getStorage
} from "firebase/storage";

const firebaseConfig = {

  apiKey: "YOUR_API_KEY",

  authDomain: "campaleads-489609.firebaseapp.com",

  projectId: "campaleads-489609",

  storageBucket: "campaleads-489609.appspot.com",

  messagingSenderId: "XXXX",

  appId: "XXXX"

};

const app = initializeApp(firebaseConfig);

// FIRESTORE
export const db = getFirestore(app);

// STORAGE
export const storage = getStorage(app);